import React, { useEffect, useState } from 'react'
import api from '../components/api'
import { dataTableRender, fmtMoney, sleep } from '../components/functions'
import { useHistory } from 'react-router-dom'



const FiqueInformado = () => {

    const history = useHistory()

    var [resultado, setResultado] = useState()
    var [totalGeral, setTotalGeral] = useState(0)


    async function carrega() {

        await api.get('fiqueInformado').then((result) => {



            setResultado(result.data.map((rs) =>
            
                <tr key={rs.fiqueInformado_id} style={{ cursor: 'pointer'}} onClick={() => history.push(`/FiqueInformado/${rs.fiqueInformado_id}`)}>
                    <td>
                        {rs.dataISO}
                    </td>
                    <td>
                        {rs.nome}
                    </td>
                    <td>
                        {rs.email}
                    </td>
                </tr>
            
            ))

        })

        dataTableRender('tabelaInscritos')

    }



    async function fiqueInformadoTotal() {

        await api.get('fiqueInformadoTotal').then((result) => {

            setTotalGeral(result.data[0].total)

        }).catch((err) => {

            console.log(err.response)

        })

    }


    async function geraExcel() {

        //return false

        window.toastr.info('Aguarde, gerando XLSX...')

        await api.get('fiqueInformadoGeraExcel').then((result) => {

            //console.log(result.data)

            if (result.data[0].status == 'ok') {

                sleep(1000).then(() => {

                    //console.log(result.data[0].fileNameCompleto, '!!')
                    window.location.href = result.data[0].fileNameCompleto
                    //window.location.href = `http://172.16.1.253:3600/${result.data.arquivo}`

                })
                

            }

        }).catch((err) => {

            console.log(err.response)

        })

    }


    useEffect(() => {

        carrega()
        fiqueInformadoTotal()
        
        
    }, [])


    return (

        <div>
            <div class='content-header'>
                <div class='header-icon'>
                    <i class='pe-7s-pin'></i>
                </div>
                <div class='header-title'>
                    <h1>Comunicação</h1>
                    <small>Fique Informado</small>
                    
                </div>
            </div>



            <div className="row">

                
                <ul className="nav nav-tabs">
                    <li className="active"><a href="#tab1" data-toggle="tab" >Inscritos ({fmtMoney(totalGeral).replace(',00','')})</a></li>
                    <li ><a href="#tab2" data-toggle="tab" >Números</a></li>
                    
                    
                    
                </ul>
                        
                <div class="tab-content">
                    <div class="tab-pane fade in active" id="tab1">
                        <div class="panel-body">


                            <button type="button" class="btn btn-success" onClick={() => geraExcel()}>Exportar XLS</button>&nbsp;
                            <br/><br/>
                                    
                            <div className="table-responsive">
                                <table id="tabelaInscritos" className="table table-bordered table-striped table-hover">
                                    <thead>
                                        <tr>

                                            <th style={{ width: '150px'}}><center>Inscrição em</center></th>
                                            <th>Nome</th>
                                           
                                            <th>E-mail</th>
                                          
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {resultado}
                                    </tbody>
                                    
                                </table>
                            </div>
                                
                        


                        </div>
                    </div>
                    
                    <div className="tab-pane fade in" id="tab2">
                        <div className="panel-body">

                            Estatísticas aqui


                        </div>

                    </div>


                    
                </div>


                
            </div>

        


        </div>

    )


}


export default FiqueInformado